export default function TablePagination({itemsPerPage, amount, currentPage, updateTablePage}) {
    const active = itemsPerPage < amount && 'active';
    const pages = Math.ceil(amount/itemsPerPage);

    const handlePageChange = function(toPage){
        if (toPage === 'prev' || toPage === 'next') {
            NextPrev(toPage)
        } else {
            updateTablePage(toPage);
        }
    
        function NextPrev(calcFormat) {
            if (calcFormat === 'prev') {
                updateTablePage(currentPage - 1);
            } else {
                updateTablePage(currentPage + 1);
            }
        }
    }

    return (
        <ul className={`pagination ${active || ''}`}>
            <li className="prev" onClick={()=>handlePageChange('prev')}></li>
            {Array(pages).fill(1).map((value, i) => {
                return (
                    <li key={(itemsPerPage/amount) + i + currentPage}
                        className={(i+1) === currentPage ? 'active' : ''}
                        onClick={()=>handlePageChange(i+1)}>
                        {i+1}
                    </li>
                );
            })}
            <li className="next" onClick={()=>handlePageChange('next')}></li>
        </ul>
    );
}